import React from 'react';
import requestIp from 'request-ip';
import LocationsPage from '@artemis/containers/LocationsPage';
import { loadIpData } from '@artemis/store/ipData/slice';
import { loadMerchantGroup } from '@artemis/store/merchantGroup/slice';
import { loadResourceSet } from '@artemis/store/resourceSet/slice';
import commonStrings from '@artemis/utils/common-strings.json';
import { MERCHANT_GROUP_PARAM } from '@artemis/utils/query/constants';

const Locations = () => <LocationsPage />;

// This gets called on every request
Locations.getInitialProps = async ctx => {
  const { contentfulLocale, isServer, query, req, store } = ctx;
  if (isServer) {
    const ipAddress = requestIp.getClientIp(req);

    store.dispatch(loadIpData({ ipAddress }));
    store.dispatch(
      loadResourceSet({
        name: ['brand', 'merchantState', ...commonStrings],
        locale: contentfulLocale,
      }),
    );
    store.dispatch(
      loadMerchantGroup({ externalId: query[MERCHANT_GROUP_PARAM] }),
    );
  }
  return {};
};

export default Locations;
